var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiBlankFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5259 28C7.53846 28 0 23.6172 0 14C0 4.38283 7.53846 0 14.5259 0C18.4079 0 21.9893 1.27728 24.644 3.60644C27.5241 6.161 29.0519 9.76744 29.0519 14C29.0519 18.2326 27.5241 21.814 24.644 24.3685C21.9893 26.6977 18.3828 28 14.5259 28Z",
    fill: "url(#paint0_radial_3056_1114)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5184 5.67773C27.8533 7.83158 28.5495 10.3962 28.5495 13.2488C28.5495 17.4813 27.0218 21.0627 24.1416 23.6173C21.4869 25.9464 17.8805 27.2488 14.0236 27.2488C9.5005 27.2488 4.75703 25.408 1.95703 21.5035C4.65184 25.9264 9.72089 28.0001 14.5245 28.0001C18.3814 28.0001 21.9878 26.6978 24.6425 24.3686C27.5227 21.814 29.0504 18.2327 29.0504 14.0001C29.0504 10.8094 28.1814 7.97434 26.5184 5.67773Z",
    fill: "#EB8F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8874 20.2868H8.36507C7.81158 20.2868 7.36328 19.8385 7.36328 19.285C7.36328 18.7315 7.81158 18.2832 8.36507 18.2832H20.8874C21.4409 18.2832 21.8892 18.7315 21.8892 19.285C21.8892 19.8385 21.4409 20.2868 20.8874 20.2868Z",
    fill: "#422B0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78483 9.75195C8.73545 9.75195 7.78125 10.6385 7.78125 12.1112C7.78125 13.5838 8.73545 14.4679 9.78483 14.4679C10.8342 14.4679 11.7884 13.5813 11.7884 12.1112C11.7884 10.641 10.8342 9.75195 9.78483 9.75195Z",
    fill: "#422B0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68666 10.7362C9.33103 10.5659 8.90277 10.7162 8.72996 11.0718C8.59722 11.3498 8.65733 11.6829 8.88023 11.8983C9.23586 12.0686 9.66413 11.9183 9.83693 11.5627C9.96967 11.2847 9.90956 10.9516 9.68666 10.7362Z",
    fill: "#896024"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3864 9.75195C18.337 9.75195 17.3828 10.6385 17.3828 12.1112C17.3828 13.5838 18.337 14.4679 19.3864 14.4679C20.4358 14.4679 21.39 13.5813 21.39 12.1112C21.39 10.641 20.4408 9.75195 19.3864 9.75195Z",
    fill: "#422B0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2921 10.7362C18.9365 10.5659 18.5082 10.7162 18.3354 11.0718C18.2027 11.3498 18.2628 11.6829 18.4857 11.8983C18.8413 12.0686 19.2696 11.9183 19.4424 11.5627C19.5751 11.2847 19.515 10.9516 19.2921 10.7362Z",
    fill: "#896024"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3056_1114",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5259 14) scale(14.2654 14.2654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiBlankFace);
export default __webpack_public_path__ + "static/media/Emoji_BlankFace.41dadb65fa35c73cd9fddce1513b0712.svg";
export { ForwardRef as ReactComponent };